<template>
  <button
    type="button"
    class="csat-input-card"
    :class="{ 'csat-input-card--selected': selected }"
    @click="$emit('update', CSAT_DISPLAY_TYPES.EMOJI)"
  >
    <span
      v-for="rating in CSAT_RATINGS"
      :key="rating.key"
      class="csat-input-card__icon"
    >
      {{ rating.emoji }}
    </span>
  </button>
</template>

<script>
import { CSAT_DISPLAY_TYPES, CSAT_RATINGS } from 'shared/constants/messages';

export default {
  name: 'CSATEmojiInput',
  props: {
    selected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      CSAT_DISPLAY_TYPES,
      CSAT_RATINGS,
    };
  },
};
</script>

<style scoped lang="scss">
.csat-input-card {
  align-items: center;
  background: var(--white);
  border: 1px solid var(--color-border);
  border-radius: var(--border-radius-medium);
  cursor: pointer;
  display: flex;
  flex-direction: row;
  gap: var(--space-smaller);
  padding: var(--space-normal);

  &--selected {
    border-color: var(--w-500);
  }

  &__icon {
    font-size: var(--font-size-big);
  }
}
</style>
